import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import * as _ from 'underscore';
import * as $ from 'jquery';

import {hasClass} from 'smooth-dnd/dist/src/utils';
import set = Reflect.set;
import {PanotestService} from '../../panotest/panotest.service';

export interface QuizGroup {
  id: number;
  feedback?: Feedback;
  questions?: QuizQuestion[];
  tryAgain?: boolean;
  submit?: boolean;
  cycle?: boolean;
  audioPrompt?: string;
  style?: object;

}

export interface QuizQuestion {
  id: number;
  question: string;
  responses: Response[];
  responseType?: number,
  type: number;
  state?: number;
  answer: number[];
  submit?: boolean;
  toggle?: boolean;
  passed?: boolean;
  feedback?: Feedback;
  feedbackPerQuestion?: true;
  childrenQuestions?: QuizQuestion[];
}
export interface Response {
  id: number;
  text: string;
  weight: number;
  imageUrl?: string;
  feedback?: Feedback;
  selected?: boolean;
  state?: number;
  order?: number;

}
export interface Feedback {
  correct?: string;
  correctHTML?: number;
  incorrect?: string;
  incorrectHTML?: number;
  incorrectReplaceContent?: boolean;
  correctReplaceContent?: boolean;
}

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.pug',
  styleUrls: ['./quiz.component.sass']
})


export class QuizComponent implements OnInit {

  @Input() options: any;
  @Input() quizGroup: QuizGroup;
  @Output() close = new EventEmitter();
  // vars
  quizIdx: number = 0;
  currentQuestion: QuizQuestion;
  feedback: string ='';
  finalFeedback: string ='';

  readyToSubmit: boolean = false;
  showSubmit: boolean = false;
  showTry: boolean = false;
  cycle: boolean = false;
  // model
  qData: QuizQuestion[]=[];
  quizData: QuizQuestion[];

  showHtmlFeedback: boolean = false;
  htmlFeedbackId: number =0;
  galleryMode = 0;

  panoservice: PanotestService
  constructor(panoservice: PanotestService) {
    this.panoservice = panoservice;
  }

  ngOnInit(): void {
    this.reset();
    if(this.quizGroup.audioPrompt) {
      this.panoservice.ui.playAudioPrompt(this.quizGroup.audioPrompt)
    }

  }

  matchSrc = 0;
  matches = [0, 0, 0, 0];
  srcText = ['Grab', 'How\'s it going?','Cheers','No worries'];
  matched = ['','','','']

  saIdx=0;
  sa1=0;
  sa2=0;
  sa3=0;
  sa4=0;
  slideShow1=0;




  matchSrcSelect(idx) {
    this.matchSrc = idx;
  }

  matchTargetSelect(r){
    //we want to shuffle the matches.
    //a=1 b=4

    this.matches[this.matchSrc-1] = r.id; //just track we attempted it
    this.matched[this.matchSrc-1]='<b> = '+r.text+'</b>'

    console.log(this.matches);

    if(this.matches.indexOf(0)==-1){
      //yay!
      this.showSubmit=true;
      this.readyToSubmit = true;
    }

  }


  reset() {
    this.quizData  = this.quizGroup.questions;
    this.currentQuestion = this.quizData[0];

    _.each(this.quizData, (q, idx) => {
        q.passed = false;
        _.each(q.responses, (r) =>{
          r.state = 0;
        })
    });

    this.readyToSubmit = false;
    this.quizIdx = 0;
    this.feedback = '';
    this.finalFeedback = '';
    if ( this.quizGroup.submit ) this.showSubmit = this.quizGroup.submit;
    if ( this.quizGroup.cycle ) this.cycle = this.quizGroup.cycle;

  }

  back(){
    if(this.quizIdx > 0) this.quizIdx--;
    this.feedback = '';
  }
  next(){
    console.log('NEXT BTN')
    $('#next').removeClass('animated heartBeat repeat3 highlight');
    this.feedback = '';
    if(this.quizIdx < this.quizData.length - 1){
      this.quizIdx++; //next question
    }else{
      console.log(this.quizIdx +" l: " + this.quizData.length)

      if(this.quizGroup.feedback) {
        console.log('Show final Quiz Feedback')
        this.processFinal();
      }else{
        console.log('NO FINAL FEEDBACK');
      }

    }







  }
  disableNext(){
    if(this.quizGroup.feedback){
      //we have feedback to show at the end of this
      return this.quizIdx === this.quizData.length
    }else {
      //Nope. lets limit it at the final question
      return this.quizIdx === this.quizData.length - 1
    }
  }
  onSubmit(qd: QuizQuestion[]) {
    console.log('Submit');
    let correct = 0;
    this.readyToSubmit = false;

    if (qd.length == 1) {
      const q = qd[0];

        if (q.type === 2 || q.type === 2.2) {
          //True False. Needs to be a single question only.
          _.each(q.responses, (item, idx) => {
            if (item.state == 1 && item.weight == 1) correct++;
            if (item.state == 2 && item.weight == 0) correct++;
          });
          console.log('TF ', correct, q.responses.length);

          if (correct === q.responses.length) {
            this.doCorrect(q.feedback);
          } else {
            this.doIncorrect(q.feedback);
          }


        }

        if (q.type === 2.1) {
          console.log('QType 2.1')

          //True False. Needs to be a single question only.
          _.each(q.responses, (item, idx) => {
            console.log(item.state, item.weight)
            if (item.state == 1 && item.weight == 1) correct++;
            if (item.state == 2 && item.weight == 0) correct++;
          });
          console.log('TF ', correct);



          if (correct === q.responses.length) {
            this.doHtmlFeedback(this.quizGroup.feedback.correctHTML);
          } else {
            this.doHtmlFeedback(this.quizGroup.feedback.incorrectHTML);
          }



        }




        if (q.type === 5) {
      console.log(this.matches);
      console.log('MATCHES', this.matches.toString())
      if(this.matches.toString() === '4,3,2,1') {
        //correct
        this.doHtmlFeedback(this.quizGroup.feedback.correctHTML)
      }else{
        this.doHtmlFeedback(this.quizGroup.feedback.incorrectHTML)
      }
    }

    } else {

      //Multiple Drop Downs
      _.each(this.quizData, (q, idx) => {
        if (q.passed) correct++
      });


      this.processFinal();



  }




  }

  processFinal(){

    console.log('PROCESS FINAL FEEDBACK')

    let correct = 0
    let attempted = 0;

    _.each(this.quizData, (q, idx) => {
      if (q.passed) correct++;
      if (q.state > 0) attempted++;
    });


    if(attempted !== this.quizData.length){
      console.log('Not finished', this.quizIdx, this.quizData.length)
      if(this.quizIdx<this.quizData.length) {
        const el = $('#next')[0];
        this.highlightNextButton();
      }
      return;

    }else{

      if(this.quizGroup.feedback) {
        // Use the Group feedback
        console.log('USE GROUP FEEDBACK')
        if (correct === this.quizData.length) {
          this.doCorrect(this.quizGroup.feedback,true);
        } else {
          this.doIncorrect(this.quizGroup.feedback, true);
        }

      }




    }






  }

  highlightNextButton(){
    console.log('Highlight Next Button');
    $('#next').removeClass('animated heartBeat repeat3 highlight');
    $('#next').addClass('animated heartBeat repeat3 highlight');
  }

  doFinalFeedback(){

  }


  doIncorrect(f: Feedback, finalFeedback: boolean = false){
    console.log('InCorrect');
    this.showSubmit = false;

    if(this.quizGroup.tryAgain) this.showTry = true;

    if ( finalFeedback ) {

      if(f.incorrectHTML) {
        this.doHtmlFeedback(f.incorrectHTML);
      } else {
        //this.finalFeedback = this.getIncorrectFeedback(f);
        setTimeout(()=>{this.finalFeedback = this.getIncorrectFeedback(f);}, 2000)
      }

    } else {
      //use normal feedback for per question feedback
      if(f.incorrectHTML) {
        this.doHtmlFeedback(f.incorrectHTML);
      } else {
        this.feedback = this.getIncorrectFeedback(f);
      }
    }

    //this.highlightNextButton();

  }

  doHtmlFeedback(id: number){
    //use html divs for feedback


    this.htmlFeedbackId = id;
    this.showHtmlFeedback = true;
    $('.quizPanel').hide();    //hide quiz
    $('.finalFeedback').hide();
    console.log('Show HTML Feedback ' + id )
  }

  doCorrect(f: Feedback, finalFeedback: boolean = false){
    console.log('Correct');
    this.showSubmit = false;
    this.showTry = false;
    if(finalFeedback) {
      if(f.correctHTML) {
        this.doHtmlFeedback(f.correctHTML);
      }else{
        setTimeout(()=>{this.finalFeedback = this.getCorrectFeedback(f);}, 2000)

      }

    } else {
      this.feedback = this.getCorrectFeedback(f);
    }

    //this.highlightNextButton();

  }

  getCorrectFeedback(f){
    return (f.correctHTML) ? $(f.correctHTML).html() : f.correct;
  }
  getIncorrectFeedback(f){
    return (f.incorrectHTML) ? $(f.incorrectHTML).html() : f.incorrect;
  }

  onTry(){
    for(let qi = 0; qi < this.quizData.length; qi++){

      let q = this.quizData[qi];
      q.passed = false;                         //unpassed
      _.each(q.responses, (item) => {
        item.state = 0});
        //clear the states for the responses
    }


    this.feedback = '';
    this.showTry=false;
    this.showSubmit=true;
  }

  onClick(q: QuizQuestion, r: Response, state: number = 0) {
    console.log('Response Click type=' + q.type + " weight:" + r.weight + ' --' + r.text);

    r.selected = true;
    q.state = 1;
    if (state) r.state = state;

    if (r.weight === 1 && (q.type === 1 || q.type === 1.1)) {
      q.passed = true;
    } else {
      q.passed = false;
    }

    //do we need to unlock submit


    this.handleResponse(q);
    //this.processFinal();
    //IS the is the kasr question and we have Quiz feedback?

  }

  onTFClick(q: QuizQuestion, r: Response, state: number = 0){
    console.log('TF Click ' + r.text);

    r.selected = true;
    q.state = 1;

    if (state) r.state = state;

    //True false array
    const picked = _.every(q.responses, (item) => {
      return item.state > 0;
    });

    if(picked) this.readyToSubmit = true; //All chosen



  }

  onDropSelect(event, q: QuizQuestion) {
    const v = event.target.value;
    q.state = 1;  //answered

    console.log(q)

    if(q.responses[v].weight > 0 ){
      q.passed = true;
    }

    if(q.type === 3) {
      const picked = _.every(this.quizData, (item) => {
        return item.state > 0;
      });
      if(this.quizGroup.submit){
        this.readyToSubmit = (picked) ? true : false;
      } else{
        //If we are not submitting the feedback MUST be per question. Doubt if HTML is being used
        console.log('Set generic feedback');
        if(q.feedback) this.feedback = (q.passed) ? q.feedback.correct : q.feedback.incorrect;

        this.highlightNextButton();

        //this.processFinal();
        //If we have Quiz feedback the next button should become active so we can show it.

      }
    }

    console.log(this.quizData);


  }

  handleResponse(q: QuizQuestion){
    console.log('Handle Response');
    if(q.submit) {
      //Submit will handle feedback
    }else{

      this.feedback = (q.passed) ? this.getCorrectFeedback(q.feedback) : this.getIncorrectFeedback(q.feedback);
      this.highlightNextButton();


    }
  }

  closePanel() {
    this.reset();
    this.close.emit({});

  }

  //all



}
